import { postForm } from './BaseRequests'


export const postContact = ({ message, subject, name, email,  phone }, success, fail) => {
    postForm("contact_form", { message, subject, name, email,  phone })
        .then(response => {
            if (response.success) {
                success(true)
            } else {
                if (response.message) {
                    fail(response.message)
                }
                fail("Error with contact request")
            }
        }).catch(fail)
}

export const postFeedback = ({clarityBoolean,clarityText,requestBoolean,requestText,savingsBoolean,savingsText,upgradeBoolean,upgradeText,extra}, success,fail)=>{
  postForm("feedback_form", {clarityBoolean,clarityText,requestBoolean,requestText,savingsBoolean,savingsText,upgradeBoolean,upgradeText,extra})
      .then(response => {
          if (response.success) {
              success(true)
          } else {
              if (response.message) {
                  fail(response.message)
              }
              fail("Error with contact request")
          }
      }).catch(fail)
}

export const postRejoinRequest = ({ name, email, phone, membershipNumber, membershipLevel }, success, fail) => {
    postForm("rejoin_form", { name, email, phone, membershipNumber, membershipLevel })
        .then(response => {
            if (response.success) {
                success(true)
            } else {
                if (response.message) {
                    fail(response.message)
                }
                fail("Error with rejoin request")
            }
        }).catch(fail)
}

export const postMemberBizRequest = ({email, name}, success, fail) => {
	postForm("memberBizRequest", { email: email, name: name })
		.then(response => {
			if (response.success) {
				success(true)
			} else {
				if(response.message) {
					fail(response.message)
				}
				fail("Error with MemberBiz Request")
			}
		}).catch(fail)
}